import { Folder } from "lucide-react";
import type { DockKindDef } from "../../registry";
import { FilesPanel } from "./FilesPanel";
import { filesPanel } from "./data";

export { browsePath, commandResultMarkdown, filesData, filesPanel, splitArgv, type FilesData, type WorkspaceArea } from "./data";

/**
 * The files kind (bots B1, 2026-09-03): a project workspace browser in the
 * dock. It CAN be conjured from the rail (`create`) — a workspace exists
 * for every project — so the rail's long-standing "Files (not built yet)"
 * placeholder becomes a real button. One panel per project (stable id).
 */
export const filesKind: DockKindDef = {
	tabIcon: () => <Folder size={13} />,
	Body: FilesPanel,
	create: () => filesPanel(""),
};
